"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.poolInvariant = exports.PoolError = exports.PoolErrCode = void 0;
const types_1 = require("../error/types");
var PoolErrCode;
(function (PoolErrCode) {
    PoolErrCode["LEFTPT_GREATER_THAN_CURRENTPT_ERROR"] = "LEFTPT_GREATER_THAN_CURRENTPT_ERROR";
    PoolErrCode["RIGHTPT_LESS_THAN_CURRENTPT_ERROR"] = "RIGHTPT_LESS_THAN_CURRENTPT_ERROR";
})(PoolErrCode = exports.PoolErrCode || (exports.PoolErrCode = {}));
class PoolError extends types_1.iZiSwapError {
    constructor(code, msg) {
        super(types_1.SDKModule.POOL, code, msg);
    }
}
exports.PoolError = PoolError;
const poolInvariant = (cond, code, msg = '') => {
    if (!cond) {
        throw new PoolError(code, msg);
    }
};
exports.poolInvariant = poolInvariant;
